module.exports = __webpack_public_path__ + "media/images/vantagens-d9da24c3b4431d5dbbf79fc234a81a94.svg";